import request from '@/axios'

export function storePayment (customer_id, payload) {
  return request({
    url:`payment/store/paypal/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function stripeCreateTokenApi () {
  return request({
    url:'payment/stripe/setup/intent',
    method:'GET'
  })
}

export function stripeCreatePaymentApi (payload) {
  return request({
    url:'stripe/create-payment',
    method:'POST',
    data:payload
  })
}

export function fetchPaymentOptionsApi () {
  return request({
    url:'operationalUser/payment/options',
    method:'GET'
  })
}